<template>
  <div
    v-if="hasSlotDefault"
    class="sidebar-header">
    <slot />
  </div>
</template>
<script>
export default {
  computed: {
    hasSlotDefault() {
      return !!this.$slots.default;
    }
  }
};
</script>
